import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'

export const HintsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  max-width: 730px;
  margin: 16px 0 0;
  justify-content: start;
  gap: 12px;
  margin-bottom: 20px;
  contain: content;
  padding-left: 0;
  list-style: none;

  ${mediaUp('lg')} {
    gap: 8px;
    justify-content: start;
  }

  ${mediaUp('md')} {
    justify-content: start;
  }
`

export const Wrapper = styled.div`
  margin-bottom: 0;
`

export const ParkFlyWrapper = styled.div`
  margin-top: 48px;
  margin-bottom: 0;
  contain: content;

  ${mediaUp('md')} {
    margin-top: 36px;
    @media (min-width: 1024px) {
      width: 1024px;
    }
  }
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  contain: content;
`

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`

export const HintsListItem = styled.li`
  display: flex;
  align-items: center;
  width: fit-content;
`

export const HintsListItemLink = styled.a`
  color: #1574e0;
  font-family: Nunito, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
  padding: 4px 8px 4px 0px;
  border-radius: 2px;
  transition: color 0.2s ease, text-decoration 0.2s ease;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${colors.twilightBlue};
    outline-offset: 2px;
  }

  ${mediaUp('lg')} {
    font-size: 18px;
  }
`

export const HintsListItemButton = styled.button<{ selected: boolean }>`
  color: ${({ selected }) =>
    selected ? colors.twilightBlue : colors.darkSkyBlue};
  font-family: Nunito, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: none;
  border: none;
  padding: 4px 2px;
  cursor: pointer;
  transition: color 0.2s ease, text-decoration 0.2s ease;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${colors.twilightBlue};
    outline-offset: 2px;
  }

  ${mediaUp('lg')} {
    font-size: 18px;
  }
`

export const Dot = styled.img`
  margin: 0 8px;
  display: inline-block;

  ${mediaUp('lg')} {
    margin: 0 16px;
  }
`

export const CategoryWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  padding-top: 4px;
  contain: content;
  gap: 12px;

  ${mediaUp('md')} {
    align-items: center;
    margin-bottom: 24px;
    padding-top: 0;
    gap: 24px;
  }
`

export const IconWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 17px;
  padding-top: 2px;
  background: ${colors.greenishCyan};
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaUp('md')} {
    width: 30px;
    height: 30px;
  }
`

export const ShowAll = styled.a`
  height: 24px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  vertical-align: middle;
  color: ${colors.twilightBlue};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
